window.PXUTheme = window.PXUTheme || {};
window.PXUTheme.jsFAQ = {
  init() {
    const faqHeadings = document.querySelectorAll('.faq-accordion > .faq-accordion-div > dt > button');
    const allContents = document.querySelectorAll('.faq-accordion > .faq-accordion-div > dd');

    // 初始化隐藏所有内容
    allContents.forEach(dd => {
      dd.setAttribute('aria-hidden', 'true');
      dd.style.maxHeight = '0';
      dd.style.overflow = 'hidden';
      dd.style.transition = 'max-height 0.3s ease';
      dd.style.borderBottom = '1px solid #f1f1f1';
    });

    faqHeadings.forEach(button => {
      button.setAttribute('aria-expanded', 'false');

      button.addEventListener('click', function (e) {
        const dt = button.parentElement;
        const dd = dt.nextElementSibling;
        const isExpanded = button.getAttribute('aria-expanded') === 'true';
        const icon = button.querySelector('.icon');

        // 先处理视觉样式
        if (!isExpanded) {
          dd.style.borderBottom = '1px solid #505050';
          dt.style.borderBottom = 'none';
        }

        // toggle aria
        button.setAttribute('aria-expanded', String(!isExpanded));
        dd.setAttribute('aria-hidden', String(isExpanded));

        // toggle content
        if (!isExpanded) {
          dd.style.maxHeight = dd.scrollHeight + 'px';
        } else {
          dd.style.maxHeight = '0';
          setTimeout(() => {
            dt.style.borderBottom = '1px solid #f1f1f1';
          }, 300);
        }

        // toggle icon class
        if (icon && icon.classList.contains('icon--active')) {
          icon.classList.toggle('icon--active');
        }

        e.preventDefault();
        return false;
      });

      // 键盘支持：回车触发点击
      button.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.keyCode === 13) {
          e.preventDefault();
          button.click();
        }
      });
    });
  },

  unload() {
    const faqHeadings = document.querySelectorAll('.faq-accordion > .faq-accordion-div > dt > button');
    faqHeadings.forEach(button => {
      const newButton = button.cloneNode(true); // 清除所有事件
      button.parentNode.replaceChild(newButton, button);
    });
  }
};
